import { type ElementType, type HTMLAttributes, type ReactNode } from 'react';
import classnames from 'src/util/classnames';

interface ListGroupProps extends HTMLAttributes<HTMLUListElement> {
  flush?: boolean;
  numbered?: boolean;
  horizontal?: boolean | string;
  tag?: ElementType;
  children?: ReactNode;
}

export function ListGroup({ flush, numbered, horizontal, tag: Tag = 'ul', className, children, ...props }: ListGroupProps) {
  return (
    <Tag
      className={classnames(
        'list-group',
        flush && 'list-group-flush',
        numbered && 'list-group-numbered',
        horizontal === true ? 'list-group-horizontal'
          : typeof horizontal === 'string' ? `list-group-horizontal-${horizontal}`
          : undefined,
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}

interface ListGroupItemProps extends HTMLAttributes<HTMLLIElement> {
  active?: boolean;
  disabled?: boolean;
  color?: string;
  action?: boolean;
  tag?: ElementType;
  children?: ReactNode;
}

export function ListGroupItem({ active, disabled, color, action, tag: Tag = 'li', className, children, ...props }: ListGroupItemProps) {
  return (
    <Tag
      className={classnames(
        'list-group-item',
        action && 'list-group-item-action',
        active && 'active',
        disabled && 'disabled',
        color && `list-group-item-${color}`,
        className,
      )}
      aria-disabled={disabled}
      {...props}
    >
      {children}
    </Tag>
  );
}
